import React from 'react';
import type { IconSidebarMenu } from 'commons/modules/SidebarMenu/icon-sidebar-menu';
import { MENU_KEYS } from 'constants/constants';

const PortfoliosIcon = ({
  currentImage,
  isExpanded,
  disabled,
  returnPath,
  open,
}: IconSidebarMenu) => {
  const logicOp = () => {
    const currentImg = currentImage === MENU_KEYS.portfolioRebalance;
    const expanded = isExpanded === `panel${MENU_KEYS.portfolioRebalance}`;
    const path =
      returnPath('/portafolio-modelo/portafolios') ||
      returnPath('/portafolio-modelo/estrategia') ||
      returnPath('/portafolio-modelo/restricciones') ||
      returnPath('/portafolio-modelo/rebalanceo');

    return Boolean(currentImg || (path && !open) || (expanded && open));
  };
  if (disabled && currentImage !== MENU_KEYS.portfolioRebalance)
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#525067" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2929 13.2929C23.4804 13.1054 23.7348 13 24 13C25.4445 13 26.8749 13.2845 28.2095 13.8373C29.5441 14.3901 30.7567 15.2004 31.7782 16.2218C32.7996 17.2433 33.6099 18.4559 34.1627 19.7905C34.7155 21.1251 35 22.5555 35 24C35 24.5523 34.5523 25 34 25H24C23.4477 25 23 24.5523 23 24V14C23 13.7348 23.1054 13.4804 23.2929 13.2929ZM25 15.0557V23H32.9443C32.8505 22.1614 32.6391 21.3385 32.3149 20.5558C31.8626 19.4639 31.1997 18.4718 30.364 17.636C29.5282 16.8003 28.5361 16.1374 27.4442 15.6851C26.6615 15.3609 25.8386 15.1495 25 15.0557ZM20.9169 14.4346C21.1378 14.9408 20.9066 15.5302 20.4004 15.7511C19.053 16.3391 17.8701 17.2482 16.9552 18.399C16.0403 19.5497 15.4212 20.907 15.1521 22.3523C14.883 23.7976 14.972 25.2868 15.4113 26.6897C15.8507 28.0926 16.627 29.3665 17.6725 30.4001C18.7179 31.4337 20.0006 32.1954 21.4085 32.6187C22.8163 33.0421 24.3065 33.114 25.7486 32.8284C27.1907 32.5428 28.5408 31.9083 29.6811 30.9803C30.8213 30.0523 31.7168 28.8592 32.2894 27.5051C32.5045 26.9965 33.0912 26.7585 33.5999 26.9736C34.1085 27.1887 34.3465 27.7754 34.1314 28.2841C33.4316 29.939 32.3371 31.3973 30.9435 32.5315C29.5499 33.6657 27.8997 34.4412 26.1371 34.7903C24.3746 35.1394 22.5533 35.0514 20.8326 34.534C19.1119 34.0167 17.5441 33.0856 16.2664 31.8224C14.9886 30.5591 14.0397 29.0021 13.5027 27.2874C12.9657 25.5727 12.857 23.7526 13.1859 21.9862C13.5148 20.2197 14.2715 18.5608 15.3897 17.1543C16.5079 15.7478 17.9536 14.6367 19.6004 13.9181C20.1066 13.6972 20.696 13.9284 20.9169 14.4346Z"
          fill="#757A96"
        />
      </svg>
    );

  if (logicOp())
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#F4F2F9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2929 13.2929C23.4804 13.1054 23.7348 13 24 13C25.4445 13 26.8749 13.2845 28.2095 13.8373C29.5441 14.3901 30.7567 15.2004 31.7782 16.2218C32.7996 17.2433 33.6099 18.4559 34.1627 19.7905C34.7155 21.1251 35 22.5555 35 24C35 24.5523 34.5523 25 34 25H24C23.4477 25 23 24.5523 23 24V14C23 13.7348 23.1054 13.4804 23.2929 13.2929ZM25 15.0557V23H32.9443C32.8505 22.1614 32.6391 21.3385 32.3149 20.5558C31.8626 19.4639 31.1997 18.4718 30.364 17.636C29.5282 16.8003 28.5361 16.1374 27.4442 15.6851C26.6615 15.3609 25.8386 15.1495 25 15.0557ZM20.9169 14.4346C21.1378 14.9408 20.9066 15.5302 20.4004 15.7511C19.053 16.3391 17.8701 17.2482 16.9552 18.399C16.0403 19.5497 15.4212 20.907 15.1521 22.3523C14.883 23.7976 14.972 25.2868 15.4113 26.6897C15.8507 28.0926 16.627 29.3665 17.6725 30.4001C18.7179 31.4337 20.0006 32.1954 21.4085 32.6187C22.8163 33.0421 24.3065 33.114 25.7486 32.8284C27.1907 32.5428 28.5408 31.9083 29.6811 30.9803C30.8213 30.0523 31.7168 28.8592 32.2894 27.5051C32.5045 26.9965 33.0912 26.7585 33.5999 26.9736C34.1085 27.1887 34.3465 27.7754 34.1314 28.2841C33.4316 29.939 32.3371 31.3973 30.9435 32.5315C29.5499 33.6657 27.8997 34.4412 26.1371 34.7903C24.3746 35.1394 22.5533 35.0514 20.8326 34.534C19.1119 34.0167 17.5441 33.0856 16.2664 31.8224C14.9886 30.5591 14.0397 29.0021 13.5027 27.2874C12.9657 25.5727 12.857 23.7526 13.1859 21.9862C13.5148 20.2197 14.2715 18.5608 15.3897 17.1543C16.5079 15.7478 17.9536 14.6367 19.6004 13.9181C20.1066 13.6972 20.696 13.9284 20.9169 14.4346Z"
          fill="#6D46DD"
        />
      </svg>
    );

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" fill="#525067" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2929 13.2929C23.4804 13.1054 23.7348 13 24 13C25.4445 13 26.8749 13.2845 28.2095 13.8373C29.5441 14.3901 30.7567 15.2004 31.7782 16.2218C32.7996 17.2433 33.6099 18.4559 34.1627 19.7905C34.7155 21.1251 35 22.5555 35 24C35 24.5523 34.5523 25 34 25H24C23.4477 25 23 24.5523 23 24V14C23 13.7348 23.1054 13.4804 23.2929 13.2929ZM25 15.0557V23H32.9443C32.8505 22.1614 32.6391 21.3385 32.3149 20.5558C31.8626 19.4639 31.1997 18.4718 30.364 17.636C29.5282 16.8003 28.5361 16.1374 27.4442 15.6851C26.6615 15.3609 25.8386 15.1495 25 15.0557ZM20.9169 14.4346C21.1378 14.9408 20.9066 15.5302 20.4004 15.7511C19.053 16.3391 17.8701 17.2482 16.9552 18.399C16.0403 19.5497 15.4212 20.907 15.1521 22.3523C14.883 23.7976 14.972 25.2868 15.4113 26.6897C15.8507 28.0926 16.627 29.3665 17.6725 30.4001C18.7179 31.4337 20.0006 32.1954 21.4085 32.6187C22.8163 33.0421 24.3065 33.114 25.7486 32.8284C27.1907 32.5428 28.5408 31.9083 29.6811 30.9803C30.8213 30.0523 31.7168 28.8592 32.2894 27.5051C32.5045 26.9965 33.0912 26.7585 33.5999 26.9736C34.1085 27.1887 34.3465 27.7754 34.1314 28.2841C33.4316 29.939 32.3371 31.3973 30.9435 32.5315C29.5499 33.6657 27.8997 34.4412 26.1371 34.7903C24.3746 35.1394 22.5533 35.0514 20.8326 34.534C19.1119 34.0167 17.5441 33.0856 16.2664 31.8224C14.9886 30.5591 14.0397 29.0021 13.5027 27.2874C12.9657 25.5727 12.857 23.7526 13.1859 21.9862C13.5148 20.2197 14.2715 18.5608 15.3897 17.1543C16.5079 15.7478 17.9536 14.6367 19.6004 13.9181C20.1066 13.6972 20.696 13.9284 20.9169 14.4346Z"
        fill="#F4F2F9"
      />
    </svg>
  );
};

export default PortfoliosIcon;
